// extracted by mini-css-extract-plugin
module.exports = {"main":"main___3Wk9f","icon":"icon___AsBzd","other":"other___3rjTK","register":"register___1IDeg","error":"error___PRx7r"};